import { curry } from 'lodash-es';

const splitFacets = facets => {
  const facetsToMerge = [];
  const facetsToKeep = [];

  facets.forEach(facet => {
    if (facet.config?.mergeInto) {
      facetsToMerge.push(facet);
    } else {
      facetsToKeep.push(facet);
    }
  });

  return { facetsToMerge, facetsToKeep };
};

const createSubGroupForMergedFacets = (facetsToMerge, subgroupsConfig) => {
  const groupedFacetsBySubGroups = facetsToMerge.reduce((acc, facet) => {
    const { type, values, config } = facet;
    const subgroupToMerge = config.mergeInto;

    return {
      ...acc,
      [subgroupToMerge]: [...(acc[subgroupToMerge] || []), ...values.map(value => ({ ...value, type, config }))],
    };
  }, {});

  return Object.entries(groupedFacetsBySubGroups).map(([subgroupName, subgroupFacets]) => {
    const subgroupConfig = subgroupsConfig[subgroupName];
    return { group: subgroupName, values: subgroupFacets, config: subgroupConfig };
  });
};

export const mergeFacets = curry((subgroupsConfig, facets) => {
  const { facetsToMerge, facetsToKeep } = splitFacets(facets);

  if (!facetsToMerge.length) return facets;

  const mergedFacets = createSubGroupForMergedFacets(facetsToMerge, subgroupsConfig);
  return [...facetsToKeep, ...mergedFacets];
});
